import { FormControl, Stack, TextField, Typography } from '@mui/material'
import React, { Dispatch, SetStateAction, useContext } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import { CustomObservabilityToolOptions } from 'components/status-checks/form/authentication/CustomObservabilityToolOptions'
import { ObservabilityToolHeaders } from 'components/status-checks/form/authentication/ObservabilityToolHeaders'
import { StatusCheckFormValues } from 'components/status-checks/status-checks-form-utils'
import { ObservabilityToolAuthenticationContext } from 'context/status-checks/ObservabilityToolAuthenticationContext'
import { useTranslation } from 'hooks/use-translation'

export const ObservabilityToolCustomAuthenticationDetails: React.FC<{
  isAuthenticationValid: boolean
  setIsAuthenticationValid: Dispatch<SetStateAction<boolean>>
}> = ({ isAuthenticationValid, setIsAuthenticationValid }) => {
  const { trans } = useTranslation()
  const { control, formState, trigger } =
    useFormContext<StatusCheckFormValues>()
  const { isEdit } = useContext(ObservabilityToolAuthenticationContext)

  return (
    <>
      <CustomObservabilityToolOptions />
      <Typography mb={2} mt={6} variant="h6">
        {trans('forms.save_status_checks.authentication.header.label')}
      </Typography>
      <Stack ml={2} spacing={3}>
        <FormControl>
          <Typography mb={2}>
            {trans(
              'forms.save_status_checks.authentication.authentication_url.prompt'
            )}
          </Typography>
          <Controller
            control={control}
            name="authenticationUrl"
            render={({ field }) => (
              <TextField
                {...field}
                data-testid="custom-observability-tool-authentication-url-input"
                disabled={isEdit}
                error={Boolean(formState.errors.authenticationUrl)}
                helperText={formState.errors.authenticationUrl?.message}
                label={trans(
                  'forms.save_status_checks.authentication.authentication_url.text_field.label'
                )}
                variant="outlined"
                onChange={async (e) => {
                  // Reset authentication state if changing authentication URL
                  if (isAuthenticationValid) {
                    setIsAuthenticationValid(false)
                  }

                  field.onChange(e)
                  await trigger('authenticationUrl')
                }}
              />
            )}
          />
        </FormControl>
        <Stack ml={2} spacing={2}>
          <Typography>
            {trans('forms.save_status_checks.authentication.headers.prompt')}
          </Typography>
          <ObservabilityToolHeaders isCustomObservabilityTool={true} />
        </Stack>
      </Stack>
    </>
  )
}
